var render = function render(_c,_vm){return _c('svgicon',{staticClass:"QuestionMark",attrs:{"icon":require('@icon/question-mark.svg?raw'),"fill":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }